import { s } from '../lib/style.js';

export function Problem() {
  return (
    <section style={s("scroll-margin-top:80px;position:relative;overflow:hidden;background:#EDEAE5;")}>
      <div
        aria-hidden="true"
        style={s("position:absolute;inset:0;pointer-events:none;background-image:repeating-linear-gradient(135deg,rgba(18,49,56,0.04) 0 1px,transparent 1px 9px);")}
      />
      <div style={s("position:relative;max-width:1220px;margin:0 auto;padding:clamp(84px,9vw,132px) 28px;")}>
        <div
          style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(300px,100%),1fr));gap:clamp(28px,4vw,56px);align-items:end;")}
        >
          <div style={s("display:flex;flex-direction:column;")}>
            <div
              style={s("align-self:flex-start;display:inline-flex;align-items:center;margin-bottom:18px;padding:9px 20px;border-radius:999px;background:#123138;border:1px solid #123138;box-shadow:0 2px 10px rgba(18,49,56,0.22);font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;letter-spacing:0.14em;text-transform:uppercase;color:#FFFFFF;")}
            >
              The problem
            </div>
            <h2
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(32px,4.2vw,54px);line-height:1.04;letter-spacing:-0.032em;margin:0;color:var(--text);")}
            >
              Managing a brand is broken and slow.
            </h2>
          </div>
          <p style={s("margin:0 0 6px;font-size:18px;line-height:1.65;color:var(--muted);")}>
            Three failures compound every week: the data won't join, the report is hand-built, and the answer sits in someone else's file.
          </p>
        </div>
        <div style={s("height:1px;margin:clamp(32px,4vw,48px) 0 0;background:rgba(18,49,56,0.16);")} />
        <div style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(260px,100%),1fr));")}>
          <div style={s("display:flex;flex-direction:column;padding:34px 34px 0 0;")}>
            <div style={s("display:flex;align-items:baseline;justify-content:space-between;gap:16px;")}>
              {' '}
              <span
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(48px,4.6vw,64px);line-height:0.9;letter-spacing:-0.04em;color:rgba(18,49,56,0.14);")}
              >
                01
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:#123138;")}
              >
                disconnected
              </span>
              {' '}
            </div>
            <h3
              style={s("margin:20px 0 0;font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(22px,2vw,25px);line-height:1.14;letter-spacing:-0.024em;text-wrap:pretty;color:var(--text);")}
            >
              Data lives everywhere
            </h3>
            <p
              style={s("margin:12px 0 0;font-size:16.5px;line-height:1.62;text-wrap:pretty;color:var(--muted);")}
            >
              Consumption, shipments, media, and retail data sit in separate systems that don't connect.
            </p>
            {' '}
            <img
              src="/assets/illustration-data-sources.webp"
              alt="Four data sources linked by dotted lines to a central store"
              style={s("display:block;width:100%;max-width:300px;margin-top:auto;padding-top:28px;aspect-ratio:1/1;object-fit:cover;opacity:0.85;")}
            />
            {' '}
          </div>
          <div
            style={s("display:flex;flex-direction:column;padding:34px 34px 0;border-left:1px solid rgba(18,49,56,0.16);")}
          >
            <div style={s("display:flex;align-items:baseline;justify-content:space-between;gap:16px;")}>
              {' '}
              <span
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(48px,4.6vw,64px);line-height:0.9;letter-spacing:-0.04em;color:rgba(18,49,56,0.14);")}
              >
                02
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:#123138;")}
              >
                manual
              </span>
              {' '}
            </div>
            <h3
              style={s("margin:20px 0 0;font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(22px,2vw,25px);line-height:1.14;letter-spacing:-0.024em;text-wrap:pretty;color:var(--text);")}
            >
              Reviews are rebuilt by hand
            </h3>
            <p
              style={s("margin:12px 0 0;font-size:16.5px;line-height:1.62;text-wrap:pretty;color:var(--muted);")}
            >
              The same report is stitched together from scratch, every single cycle.
            </p>
            {' '}
            <img
              src="/assets/illustration-report-blocks.webp"
              alt="Two people assembling a report from loose blocks"
              style={s("display:block;width:100%;max-width:300px;margin-top:auto;padding-top:28px;aspect-ratio:1/1;object-fit:cover;opacity:0.85;")}
            />
            {' '}
          </div>
          <div
            style={s("display:flex;flex-direction:column;padding:34px 0 0 34px;border-left:1px solid rgba(18,49,56,0.16);")}
          >
            <div style={s("display:flex;align-items:baseline;justify-content:space-between;gap:16px;")}>
              {' '}
              <span
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(48px,4.6vw,64px);line-height:0.9;letter-spacing:-0.04em;color:rgba(18,49,56,0.14);")}
              >
                03
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:#123138;")}
              >
                siloed
              </span>
              {' '}
            </div>
            <h3
              style={s("margin:20px 0 0;font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(22px,2vw,25px);line-height:1.14;letter-spacing:-0.024em;text-wrap:pretty;color:var(--text);")}
            >
              Work is done in silos
            </h3>
            <p
              style={s("margin:12px 0 0;font-size:16.5px;line-height:1.62;text-wrap:pretty;color:var(--muted);")}
            >
              Every team holds a different piece of the picture, with no shared way to compare it.
            </p>
            {' '}
            <img
              src="/assets/illustration-team-silos.webp"
              alt="Four teams working inside separate silos"
              style={s("display:block;width:100%;max-width:300px;margin-top:auto;padding-top:28px;aspect-ratio:1/1;object-fit:cover;opacity:0.85;")}
            />
            {' '}
          </div>
        </div>
      </div>
    </section>
  );
}
